import { IKeyFigure } from "src/api/server/extended-search";

export const getKeyFigureMinAndMaxByKeyFigureId = (
    keyFigureId: string,
    keyFiguresData: readonly IKeyFigure[]
): { defaultMinimum: number; defaultMaximum: number } => {
    const keyFigure = keyFiguresData.find(keyFigure => keyFigure.id === keyFigureId);

    if (keyFigure) {
        const defaultMinimum = keyFigure.steps[0];
        const defaultMaximum = keyFigure.steps[keyFigure.steps.length - 1];
        return { defaultMinimum, defaultMaximum };
    } else {
        throw new Error("Key figure with given id doesn't exist");
    }
};
